import { render } from "./EventPaymentSuccess.vue?vue&type=template&id=123f1422&scoped=true&ts=true"
import script from "./EventPaymentSuccess.vue?vue&type=script&lang=ts"
export * from "./EventPaymentSuccess.vue?vue&type=script&lang=ts"

import "./EventPaymentSuccess.vue?vue&type=style&index=0&id=123f1422&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123f1422"]])

export default __exports__